export enum AccessOutcome {
  DENIED = 'DENIED',
  GRANTED = 'GRANTED',
}

export enum CredentialFormat {
  MIFARE_EV2 = 18,
  MIFARE_CLASSIC = 17,
  UNIVERSAL = 255,
  BITS_26 = 0,
  MOBILE_CREDENTIAL = 20,
}

export enum EventCategory {
  ACCESS = 'ACCESS',
  ALARM = 'ALARM',
  CONFIGURATION = 'CONFIGURATION',
  DETAILED_ACCESS = 'DETAILED_ACCESS',
  HARDWARE = 'HARDWARE',
  INTEGRATION = 'INTEGRATION',
  SYSTEM = 'SYSTEM',
  WARNING = 'WARNING',
}

export enum EventPeriod {
  TODAY = 'today',
  LAST_7_DAYS = 'last-7-days',
  LAST_30_DAYS = 'last-30-days',
}

export enum EventSource {
  CLOUD = 'CLOUD',
  CONTROLLER = 'CONTROLLER',
}

export enum ProfileType {
  SYSTEM = 'system',
  DEALER = 'dealer',
  ORGANIZATION = 'organization',
}

export enum RoleNames {
  // System User
  SUPERADMIN = 'Super Admin',
  CUSTOMER_SUPPORT = 'Customer Support',
  ADMINISTRATION = 'Administration',
  MARKETING = 'Marketing',

  // Dealer User
  DEALER_ADMINISTRATOR = 'Dealer Administrator',
  DEALER_ACCOUNTS_MANAGER = 'Dealer Accounts Manager',

  // Organization User
  ACCOUNT_ADMINISTRATOR = 'Account Administrator',
  ACCOUNT_SITE_MANAGER = 'Account Site Manager',
  ACCOUNT_DOOR_MANAGER = 'Account Door Manager',
}

export enum StripeSyncIssueStatus {
  RESOLVED = 'RESOLVED',
  UNRESOLVED = 'UNRESOLVED',
}

export enum UnusedSince {
  ANY = 'any',
  LAST_MONTH = 'last_month',
  LAST_3_MONTHS = 'last_3_months',
  LAST_6_MONTHS = 'last_6_months',
  NEVER = 'never',
}

export enum DoorAccessMode {
  NORMAL = 0,
  PRIVACY = 1,
  APARTMENT = 2,
  CLASSROOM = 3,
  GLOBAL_ENTRY = 4,
  GLOBAL_EXIT = 5,
  ENTRY = 6,
  EXIT = 7,
}
